<template>
  <section class="bootcamp-how-it-works">
    <div class="how-it-works-container">
      <h2 class="header">What is a Bootcamp?</h2>
      <p class="subheader">A Bootcamp is composed of 3 major components</p>
      <div class="components-wrapper">
        <div class="components">
          <HowItWorksComponent
            :image-src="require('@/assets/images/bootcamp/enroll/how-it-works/world-class.png')"
            image-alt="World Class Curriculum"
            header="1. World Class Curriculum"
            :description="`
              Your path to improvement begins with lessons hand-selected by ${partnerName}, including 16 key concepts
              that lay the foundation for everything you need to know about Fortnite. The content comes in various forms
              to accommodate players who learn in different ways. Each video lesson will be accompanied by unique drills
              and challenges to help  directly apply what you've learned.
            `"
          ></HowItWorksComponent>
          <HowItWorksComponent
            :image-src="require('@/assets/images/bootcamp/enroll/how-it-works/live-pro-interaction.png')"
            image-alt="Live Pro Interaction"
            header="2. Live Pro Interaction"
            :description="`
              You'll get to meet ${partnerNickname} every week in live Q&A sessions where ${partnerPronounSubject}'ll be
              answering your questions, reviewing your gameplay, and most importantly, giving you direct feedback.
              Certain assignments will encourage you to submit clips of your play, and ${partnerName} will select
              ${partnerPronounPossessiveDeterminer} favorites to review live.
            `"
          ></HowItWorksComponent>
          <HowItWorksComponent
            :image-src="require('@/assets/images/bootcamp/enroll/how-it-works/private-community.png')"
            image-alt="Private Bootcamp Community"
            header="3. Private Bootcamp Community"
            :description="`
              Through taking part in this bootcamp, you'll receive an invite to ${partnerNickname}'s private Discord
              server, which will serve as your virtual classroom. There, you'll be able to ask questions, meet new
              players with similar mindsets, and potentially even find your next teammate. Some of the challenges will
              ask you to team up with another member of the bootcamp, and apply your learning together in a way you've
              never experienced before.
            `"
          ></HowItWorksComponent>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  components: {
    HowItWorksComponent: () => import("@/components/bootcamp/enroll/how-it-works/HowItWorksComponent"),
  },
  computed: {
    ...mapGetters("BootcampEnroll", [
      "bootcampPartnerByKey",
    ]),
    bootcampKey () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    partner () {
      return this.bootcampPartnerByKey(this.bootcampKey)
    },
    partnerName () {
      return this.partner?.name || "Partner"
    },
    partnerNickname () {
      return this.partner?.nickname || "Partner"
    },
    partnerPronounSubject () {
      return this.partner?.pronouns?.subject || "They"
    },
    partnerPronounPossessiveDeterminer () {
      return this.partner?.pronouns?.possessiveDeterminer || "Their"
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

.bootcamp-how-it-works {
  background: #FAFAFA;
  font-family: $font-poppins;

  .how-it-works-container {
    margin: 7rem auto;
    padding: 0rem 1rem;
    width: 100%;
    max-width: 132rem;

    .header {
      color: $bootcamp-landing-text-color-1;
      font-size: 3.5rem;
      font-weight: 500;
      margin-bottom: 1rem;
    }

    .subheader {
      color: $bootcamp-landing-text-color-3;
      font-size: 1.8rem;
      font-weight: 400;
      margin-bottom: 1rem;
    }

    .components-wrapper {
      margin: 3rem auto;
      width: 100%;

      .components {
        display: grid;
        grid-gap: 3rem;
        grid-template-columns: 1fr;
        width: 100%;

        @include min-tablet {
          border: 1px solid #E2E2E2;
          border-radius: 20px;
          grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
          padding: 6.3rem;
          flex-direction: row;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/how-it-works/TheHowItWorksSection.vue